import { useUserEmailDomain } from '@atlassian/jira-atlassian-account/src/controllers/index.tsx';
import { useIsOrgAdmin } from '@atlassian/jira-business-goal-picker/src/services/is-org-admin/index.tsx';
import { PREMIUM_EDITION } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

export const usePlatformDashboardsAudience = () => {
	const { isOrgAdmin } = useIsOrgAdmin();

	const appEditions = useAppEditions();
	const emailDomain = useUserEmailDomain(true);
	const isInternalAtlassianUser =
		emailDomain.data === 'atlassian.com' || emailDomain.data === 'usersinbuckets.com';

	if (!appEditions) {
		return false;
	}

	return (
		(appEditions.software === PREMIUM_EDITION || appEditions.serviceDesk === PREMIUM_EDITION) &&
		isOrgAdmin &&
		!isInternalAtlassianUser
	);
};
